export const WIDGET_PRESSURE_FILL_REQUEST = 'WIDGET_PRESSURE_FILL_REQUEST'
export const WIDGET_PRESSURE_FILL_SUCCESS = 'WIDGET_PRESSURE_FILL_SUCCESS'
export const WIDGET_PRESSURE_FILL_FAILURE = 'WIDGET_PRESSURE_FILL_FAILURE'
